import api from './axios'

class ServiceDfe {
  async listDfe(isSynced = '', text, type, startDate, endDate, page = 1) {
    const { data } = await api.get(`/dfe?isSynced=${isSynced}&q=${text}&type=${type}&startDate=${startDate}&endDate=${endDate}&page=${page}`);

    return data
  }

  async urlToDownload(urls) {
    const { data } = await api.post('/dfe/url/to/download-xml', { urls })

    return data
  }

  async downloadStringXMl(idNfeDfe) {
    const { data } = await api.get(`/dfe/xml/download/${idNfeDfe}`)

    return data
  }

  async generateDanfe(id) {
    const { data } = await api.get(`/dfe/danfe/${id}`)

    return data
  }

  async manifestDfe(lote) {
    const { data } = await api.post(`/dfe/manifest`, lote)

    return data
  }

  async updateSetSynced(chave) {
    await api.put(`/dfe/synced/${chave}`)
  }
}

export default new ServiceDfe
